import React from 'react';

const formatPunctuation = (text?: string | null) => {
  // Nothing to format when the text is missing or empty
  if (!text) {
    return <>{text ?? ''}</>;
  }

  const punctuationMarks = ['.', ',', '!', '?', ':'];

  // Check if the last character is a punctuation mark
  const lastChar = text.slice(-1);
  if (punctuationMarks.includes(lastChar)) {
    // If it is a punctuation mark, return JSX with the punctuation in a span
    return (
      <>
        {text.slice(0, -1)}
        <span className="text-primary-100">{lastChar}</span>
      </>
    );
  }

  // If no punctuation, return the text as it is
  return <>{text}</>;
};

export default formatPunctuation;
